import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/vehicleTypes/vehicleTypes';
import Container from './Container';


const ms2p = (state) => {
    return {
        ...state.vehicleTypes,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Container);
